import { TransformInt } from '../../../shared/decorators/transform-int.decorator';
import { UpdateTenantBillingDto } from '../../billing/dtos/update-tenant-billing.dto';

import { CreateTenantDto } from './create-tenant.dto';

/**
 * Update tenant DTO
 */
export class UpdateTenantDto extends CreateTenantDto {
  @TransformInt()
  id!: number;
  @TransformInt()
  contactId!: number;
  declare billing?: UpdateTenantBillingDto;
}
